import React, { Children, useEffect, useState } from 'react';
import { FormControl, Grid, InputLabel, Select } from '@material-ui/core';
import AppTextInput from '@jumbo/components/Common/formElements/AppTextInput';
//import { Autocomplete } from '@mui/material';
import { LABEL_INPUT_FONT_SIZE } from '../../ConstsAndUtils/utils';
import { getAutoridadesPorRegion } from 'services/api';
import { toast } from '@jumbo/components/custom/Toast';

const AsInstalacionFuncionamiento = props => {

    const [autoridadesAux, setAutoridadesAux] = useState([{ value: 0, label: 'Seleccione' },])

    const {
        nResolucion,
        fechaOtorgada,
        autoridadQueDicta,
        setNResolucion,
        setFechaOtorgada,
        setAutoridadQueDicta,
        title,
        children,
    } = props

    useEffect(() => {

        if (autoridadesAux.length === 1) {
            getAutoridadesPorRegion(sessionStorage.getItem('region'))
                .then(res => {
                    let aux = res.data.map(item => ({
                        value: item.id,
                        label: item.nombre
                    }));
                    setAutoridadesAux([{ value: 0, label: 'Seleccione' }, ...aux])
                })
                .catch(e => console.error(e))
                .finally(f => {

                })
        }

    }, [autoridadesAux])

    return (
        <Grid
            container
            item
            xs={12}
            spacing={4}
            style={{
                backgroundColor: 'white',
                paddingTop: 5,
                borderRadius: 5,
                paddingBottom: 5,
           
            }}>
{/*             <Grid item xs={12}>
                <h4>{title}</h4>
            </Grid> */}

            <Grid item xs={2}>
                <AppTextInput
                    tooltip={'El formato debe ser: 111111'}
                    InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                    fullWidth
                    size={'small'}
                    variant="outlined"
                    label="Nº Resolución"
                    value={nResolucion}
                    onChange={e => {
                        const value = e.target.value;
                        if (!/^\d*$/.test(value)) return;
                        const numericValue = value.replace(/^0+/, '');

                        if (numericValue.length <= 9) {
                            setNResolucion(numericValue);
                        }
                    }}

                    helperText={''}
                    onBlur={() => { }}
                />
            </Grid>

            <Grid item xs={2}>
                <AppTextInput
                    InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                    fullWidth
                    size={'small'}
                    variant="outlined"
                    type={"date"}
                    label="Fecha en que se otorga"
                    value={fechaOtorgada}
                    onChange={e => {

                        const selectedDate = new Date(e.target.value);
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);
                        selectedDate.setHours(0, 0, 0, 0);
                        const selectedDateString = selectedDate.toISOString().split('T')[0];
                        const todayString = today.toISOString().split('T')[0];

                        if (selectedDateString >= todayString) {
                            toast.error('La fecha no puede ser futura')
                        } else {
                            const inputDate = e.target.value;
                            const cleanedDate = inputDate.replace(/\D/g, '');
                            if (cleanedDate.length <= 2) {
                                setFechaOtorgada(cleanedDate)
                            } else if (cleanedDate.length <= 4) {
                                setFechaOtorgada(cleanedDate.slice(0, 2) + '/' + cleanedDate.slice(2))
                            } else {
                                setFechaOtorgada(cleanedDate.slice(0, 2) +
                                    '/' +
                                    cleanedDate.slice(2, 4) +
                                    '/' +
                                    cleanedDate.slice(4, 8))
                            }
                            setFechaOtorgada(e.target.value)
                        }
                    }}
                    helperText={''}
                    onBlur={() => { }}
                />
            </Grid>

            <Grid item xs={4}>

                <FormControl size='small' fullWidth>
                    <InputLabel
                        inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                        htmlFor="grouped-native-select"
                        style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                        Autoridad que la dicta
                    </InputLabel>
                    <Select
                        inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                        native
                        label='Autoridad que la dicta'
                        id="grouped-native-select"
                        fullWidth
                        variant='outlined'
                        value={autoridadQueDicta}
                        onChange={(e) => {
                            setAutoridadQueDicta(parseInt(e.target.value))
                        }}

                    >
                        {
                            autoridadesAux.map((option, index) => {
                                return <option key={index + 1} value={option.value}>
                                    {option.label}
                                </option>
                            })
                        }
                    </Select>
                </FormControl>

            </Grid>

            {children}

        </Grid>
    );
}




export default AsInstalacionFuncionamiento